import ReactGA from 'react-ga';
import {connect, setRecomputeState} from '@gisatcz/ptr-state';
import {PresentationMap} from '@gisatcz/ptr-maps';
import Action from '../../state/Action';
import Select from '../../state/Select';

const mapStateToProps = (state, ownProps) => {
	setRecomputeState(state);

	return {
		backgroundLayer: Select.maps.getMapBackgroundLayer(
			ownProps.stateMapKey
		),
		layers: Select.maps.getMapLayers(ownProps.stateMapKey),
		view: Select.maps.getViewByMapKey(state, ownProps.stateMapKey),
		viewLimits: Select.maps.getViewLimitsByMapKey(
			state,
			ownProps.stateMapKey
		),
		mapKey: ownProps.stateMapKey,
		viewport: Select.maps.getViewportByMapKey(state, ownProps.stateMapKey),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onMount: (mapWidth, mapHeight) => {
			dispatch(
				Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
			);
		},
		onResize: (mapWidth, mapHeight) => {
			dispatch(
				Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
			);
		},
		onViewChange: update => {
			dispatch(Action.maps.updateMapAndSetView(ownProps.stateMapKey, update));
		},
		onPropViewChange: (update, mapWidth, mapHeight) => {
			dispatch(
				Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
			);
		},
		onClick: view => {
			dispatch(Action.maps.setMapSetActiveMapKey(ownProps.stateMapKey));
		},
		onLayerClick: (mapKey, layerKey, selectedFeatureKeys) => {
			let action = 'Select risk assessment zone';
			if (layerKey === 'risk-assessment-zones-big') {
				dispatch(Action.selections.setActiveKey('riskAssessmentZones'));
				dispatch(
					Action.maps.setLayerSelectedFeatureKeys(
						ownProps.stateMapKey,
						layerKey,
						selectedFeatureKeys
					)
				);
				dispatch(
					Action.specific.eo4sdDrrInsarVietnam20.selectArea(
						ownProps.stateMapKey,
						layerKey,
						selectedFeatureKeys
					)
				);
			} else if (layerKey === 'risk-assessment-roads-big') {
				action = 'Select road';
				dispatch(Action.selections.setActiveKey('riskAssessmentRoads'));
				dispatch(
					Action.maps.setLayerSelectedFeatureKeys(
						ownProps.stateMapKey,
						layerKey,
						selectedFeatureKeys
					)
				);
				dispatch(
					Action.specific.eo4sdDrrInsarVietnam20.selectRoad(
						ownProps.stateMapKey,
						layerKey,
						selectedFeatureKeys
					)
				);
			}

			ReactGA.event({
				category: 'Basic interaction',
				action,
				label: 'map',
			});
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PresentationMap);
